import React from "react";
import { createRoutingObject } from "@akj-dev/shared-components";
import { Home } from "./screens/Home";

export const routes = createRoutingObject(
  [
    {
      path: "/",
      title: "Dashboard",
      subject: <Home />,
    },
  ],
  "/insight"
);
